const parameters = {
  slidesPerView: 3,
  spaceBetween: 16,
  breakpoints: {
    768: {
      spaceBetween: 32,
    },
    992: {
      allowTouchMove: false,
      slidesPerView: 'auto',
    },
  },
};

export { parameters };
